import axios from "axios";
import { toast } from "react-toastify";
import { io } from "socket.io-client";

let hostUrl = window.location.hostname;
// https://notable-sonnnie-7178.apps.resilis.net

export const baseUrl = () => {
  const baseApi = hostUrl.includes("localhost")
    ? process.env.REACT_APP_STAGING_URL || "https://tanda-secure-school-app.herokuapp.com/api/v1"
    : hostUrl.includes("vercel")
    ? process.env.REACT_APP_STAGING_URL || "https://tanda-secure-school-app.herokuapp.com/api/v1"
    : hostUrl.includes("tandasecure")
    ? process.env.REACT_APP_LIVE_URL
    : "";
  return baseApi;
};

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || "DISC-r03KmASL3y-PROD";

const token: string = localStorage.getItem("authToken") ?? "";

// https://30d5-102-89-84-95.ngrok-free.app

// https://30d5-102-89-84-95.ngrok-free.app

// process.env.REACT_APP_SOCKET_URL

export const socket = io(process.env.REACT_APP_SOCKET_URL, {
  autoConnect: true,
  extraHeaders: {
    authorization: `Bearer ${token}`,
    token: `Bearer ${token}`,
  },
  auth: {
    authorization: `Bearer ${token}`,
    token: `Bearer ${token}`,
  },
  query: {
    auth: "123",
    token: `Bearer ${token}`,
  },
  transportOptions: {
    polling: {
      extraHeaders: {
        authorization: `Bearer ${token}`,
        token: `Bearer ${token}`,
      },
    },
    extraHeaders: {
      authorization: `Bearer ${token}`,
      token: `Bearer ${token}`,
    },
  },
  transports: ["websocket"],
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  timeout: 60000,
  forceNew: true,
  withCredentials: true,
  retries: Infinity,
});

export const instance = axios.create({
  baseURL: baseUrl(),
});

instance.interceptors.request.use(
  function (config: any) {
    const token: string = localStorage.getItem("authToken") ?? "";
    config.headers["secretKey"] = SECRET_KEY;
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error: any) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("authToken");
      localStorage.clear();
      window.location.replace(`/login`);
      toast.info("Session expired");
    }
    return Promise.reject(error);
  }
);
